var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("navigation-layout", { ref: "navigationlayout" }, [
    _c("h1", { attrs: { slot: "title" }, slot: "title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { slot: "abstract" }, slot: "abstract" }, [
      _vm._v(_vm._s(_vm.abstract))
    ]),
    _vm._v(" "),
    _c("main", [
      _c("div", [
        _c(
          "form",
          {
            staticClass: "md-layout md-alignment-top-center",
            attrs: { novalidate: "" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.validateTestChain($event)
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-max-size md-medium-size-33 md-small-size-50 md-xsmall-size-100"
              },
              [
                _c("field", {
                  ref: "chainName",
                  attrs: {
                    fieldName: "chainName",
                    validations: { required: true },
                    fieldValue: _vm.form.chainName,
                    fieldLabel: "Chain name",
                    fieldId: "chainName",
                    sending: _vm.sending
                  },
                  on: {
                    setfield: function($event) {
                      return _vm.setFormField($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("field-select", {
                  ref: "integratorId",
                  attrs: {
                    fieldName: "integratorId",
                    validations: { required: true },
                    fieldValue: _vm.form.integratorId,
                    fieldLabel: "Integrator",
                    fieldId: "integratorId",
                    values: _vm.integrators,
                    valueId: "id",
                    valueLabel: "name",
                    sending: _vm.sending,
                    withId: "true"
                  },
                  on: {
                    setfield: function($event) {
                      return _vm.setFormField($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("field-select", {
                  ref: "timeZoneId",
                  attrs: {
                    fieldName: "timeZoneId",
                    validations: { required: true },
                    fieldValue: _vm.form.timeZoneId,
                    fieldLabel: "TimeZone",
                    fieldId: "timeZoneId",
                    values: _vm.timeZones,
                    valueId: "timeZoneId",
                    valueLabel: "name",
                    sending: _vm.sending,
                    withId: "true"
                  },
                  on: {
                    setfield: function($event) {
                      return _vm.setFormField($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("field-select", {
                  ref: "countryId",
                  attrs: {
                    fieldName: "countryId",
                    validations: { required: true },
                    fieldValue: _vm.form.countryId,
                    fieldLabel: "Country",
                    fieldId: "countryId",
                    values: _vm.countries,
                    valueId: "countryId",
                    valueLabel: "name",
                    sending: _vm.sending,
                    withId: "true"
                  },
                  on: {
                    setfield: function($event) {
                      return _vm.setFormField($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("field-select", {
                  ref: "languageId",
                  attrs: {
                    fieldName: "languageId",
                    validations: { required: true },
                    fieldValue: _vm.form.languageId,
                    fieldLabel: "Language",
                    fieldId: "languageId",
                    values: _vm.languages,
                    valueId: "id",
                    valueLabel: "name",
                    sending: _vm.sending,
                    withId: "true"
                  },
                  on: {
                    setfield: function($event) {
                      return _vm.setFormField($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "md-layout" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-checkbox",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true },
                              expression: "{required: true}"
                            }
                          ],
                          class: {
                            "md-invalid": _vm.errors.has(
                              "Is a chain integration"
                            )
                          },
                          attrs: { name: "Is a chain integration" },
                          model: {
                            value: _vm.form.isChainIntegration,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "isChainIntegration", $$v)
                            },
                            expression: "form.isChainIntegration"
                          }
                        },
                        [_vm._v("Is a chain integration")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "md-layout-item md-size-100" }, [
                    _vm.errors.has("Is a chain integration")
                      ? _c("span", { staticStyle: { color: "#ff1744" } }, [
                          _vm._v(
                            _vm._s(_vm.errors.first("Is a chain integration"))
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "md-title" }, [
                  _vm._v("Available modules")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "md-layout" },
                  _vm._l(_vm.modulesLayer, function(module, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "md-layout-item md-size-15 md-medium-size-35 md-small-size-50"
                      },
                      [
                        _c(
                          "md-checkbox",
                          {
                            attrs: {
                              value: module,
                              disabled: module.name === "CORE"
                            },
                            model: {
                              value: _vm.tempModules,
                              callback: function($$v) {
                                _vm.tempModules = $$v
                              },
                              expression: "tempModules"
                            }
                          },
                          [_vm._v(_vm._s(module.name))]
                        )
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.sending || _vm.loading
                  ? _c("md-progress-bar", {
                      attrs: { "md-mode": "indeterminate" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "md-button",
                  {
                    staticClass: "md-raised md-primary",
                    attrs: {
                      type: "submit",
                      disabled: _vm.sending || _vm.loading
                    }
                  },
                  [_vm._v("Create")]
                ),
                _vm._v(" "),
                _c(
                  "md-dialog",
                  {
                    attrs: { "md-active": _vm.showResultDialog },
                    on: {
                      "update:mdActive": function($event) {
                        _vm.showResultDialog = $event
                      },
                      "update:md-active": function($event) {
                        _vm.showResultDialog = $event
                      }
                    }
                  },
                  [
                    _c("md-dialog-title", [_vm._v("Results")]),
                    _vm._v(" "),
                    _vm.createdTestChainData !== null
                      ? _c(
                          "md-list",
                          { staticClass: "md-double-line" },
                          [
                            _vm.createdTestChainData.chainApiKey
                              ? _c("md-list-item", [
                                  _c(
                                    "div",
                                    { staticClass: "md-list-item-text" },
                                    [
                                      _c("span", [_vm._v("ChainApiKey")]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.createdTestChainData.chainApiKey
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(
                              _vm.createdTestChainData.facilityIntegration,
                              function(facilityIntegration, index) {
                                return _c("md-list-item", { key: index }, [
                                  _c(
                                    "div",
                                    { staticClass: "md-list-item-text" },
                                    [
                                      _c("span", [_vm._v("FacilityUrl")]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            facilityIntegration.facilityUrl
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  facilityIntegration.apiKey
                                    ? _c(
                                        "div",
                                        { staticClass: "md-list-item-text" },
                                        [
                                          _c("span", [
                                            _vm._v("FacilityApiKey")
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(facilityIntegration.apiKey)
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              }
                            ),
                            _vm._v(" "),
                            _c("md-list-item", [
                              _c("div", { staticClass: "md-list-item-text" }, [
                                _c("span", [_vm._v("ChainName")]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(_vm.form.chainName))])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("md-list-item", [
                              _c("div", { staticClass: "md-list-item-text" }, [
                                _c("span", [_vm._v("Director Username")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.createdTestChainData.directorUsername
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "md-list-item-text" }, [
                                _c("span", [_vm._v("Director Password")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.createdTestChainData.directorPassword
                                    )
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("md-list-item", [
                              _c("div", { staticClass: "md-list-item-text" }, [
                                _c("span", [_vm._v("Integration Username")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.createdTestChainData
                                        .integrationUsername
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "md-list-item-text" }, [
                                _c("span", [_vm._v("Integration Password")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.createdTestChainData
                                        .integrationPassword
                                    )
                                  )
                                ])
                              ])
                            ])
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "md-dialog-actions",
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "md-primary",
                            on: {
                              click: function($event) {
                                _vm.showResultDialog = false
                              }
                            }
                          },
                          [_vm._v("Close")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6729270a", { render: render, staticRenderFns: staticRenderFns })
  }
}